export const SUBHEADING_ARRAY = [
  "Pay the deposit for your job securely using Open Banking to finalise your finance agreement and get the job started. Once paid, we'll let ",
  '$partner',
  ' know that the job is ready to start.',
];
